module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("C")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0viii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#fore"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("Foreword")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("Preface")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" What Is a Sabertooth?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" The Ecology of Sabertooths")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" A Who’s Who of Sabertoothed Predators")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Sabertooths as Living Predators")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Extinctions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0